module.exports = __webpack_public_path__ + "static/media/shirt-cooperate-5.07f4c30c.jpg";